import { SetupStep, TaskStatus } from './stepData/d'
import { SetupTask } from './setupTasksData'

export const getTaskStatus = (taskStepIds: string[], completedStepIds: string[]): TaskStatus => {
  const completedTaskStepIds = taskStepIds.filter(id => completedStepIds.includes(id))

  if (completedTaskStepIds.length === 0) return 'NOT_STARTED'
  if (completedTaskStepIds.length === taskStepIds.length) return 'COMPLETED'

  return 'IN_PROGRESS'
}

export const validateStepData = (steps: SetupStep[], tasks: SetupTask[]) => {
  const allStepIds = steps.map(step => step.id)

  steps.forEach(step => {
    if ((step.dependsOnStepIds?.length || 0) > 0) {
      const dependsOnIdsValid = step.dependsOnStepIds!.every(stepId => allStepIds.includes(stepId))
      if (!dependsOnIdsValid) {
        throw new Error(`Step ${step.id} has invalid step id in dependsOnStepIds array`)
      }
    }
  })

  tasks.forEach(task => {
    const taskSteps = steps.filter(step => step.taskId === task.taskId)

    if (taskSteps.length === 0) {
      throw new Error(`Task ${task.taskId} has no steps`)
    }
  })
}
